import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@tagName('')
@classic
export default class SharedMarketingSortableListItem extends Component {
  isDragging = false;
}
